import React, { useState } from 'react';
import { NavDropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export const countries = [
  { key: 'AR', lang: 'es', flag: '🇦🇷', label: 'Argentina' },
  { key: 'BR', lang: 'br', flag: '🇧🇷', label: 'Brasil' },
  { key: 'UY', lang: 'es', flag: '🇺🇾', label: 'Uruguay' },
  { key: 'CL', lang: 'es', flag: '🇨🇱', label: 'Chile' },
  { key: 'CN', lang: 'zh', flag: '🇨🇳', label: '中国' }
];

export const getSelectedCountry = () => {
  const stored = localStorage.getItem('gestodo_country');
  return countries.find(c => c.key === stored) || countries[0];
};

const CountrySelector = () => {
  const { i18n } = useTranslation();
  const [selected, setSelected] = useState(getSelectedCountry);

  const handleSelect = (country) => {
    localStorage.setItem('gestodo_country', country.key);
    setSelected(country);
    i18n.changeLanguage(country.lang);
  };

  return (
    <NavDropdown
      title={<span>{selected.flag}</span>}
      id="country-selector"
      align="end"
      className="ms-2"
    >
      {countries.map((country) => (
        <NavDropdown.Item
          key={country.key}
          active={country.key === selected.key}
          onClick={() => handleSelect(country)}
        >
          {country.flag} {country.label}
        </NavDropdown.Item>
      ))}
    </NavDropdown>
  );
};

export default CountrySelector;
